// import { Navigate } from 'react-router-dom';
// import { getStoredUser } from '../utilities/encryption';
// const ProtectedRoute = ({ children }) => {
//   const user = getStoredUser();
//   const token =user.token;
//   return token ? children : <Navigate to="/login" />;
// };

// export default ProtectedRoute;



import { Navigate } from 'react-router-dom';
import { getStoredUser } from '../utilities/encryption';

const ProtectedRoute = ({ children, role }) => {
  const session = getStoredUser();

  // Safety check
  if (!session || !session.token) {
    return <Navigate to="/login" />;
  }

  // Role check (optional)
  if (role && session.data?.role !== role) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;